// @flow
import type {CheckoutDataForGlobalDataLayerType} from 'constants/flow/flowTypesGlobalDataLayer';
import type {QuoteItemType, QuotePreparedItemType} from 'constants/flow/flowTypesCart';

import {emptyStringIsFalsy, getAttribute} from '../../helpers';
import {getBadge} from '../cart/cart';

/**
 * Prepare quote item
 * @param {Array<QuoteItemType>} item - Quote item
 * @returns {QuotePreparedItemType} Prepared quote item
 */
export const prepareProductData = (item: QuoteItemType): QuotePreparedItemType => {
    return {
        attribute_set: getAttribute(item.type),
        brand: emptyStringIsFalsy(item.brand),
        color: item.frame ? emptyStringIsFalsy(item.frame.color) : '',
        frame_sku: emptyStringIsFalsy(item.product_sku),
        frame_url_path: emptyStringIsFalsy(item.frame_url_path),
        full_sku: emptyStringIsFalsy(item.sku),
        gender: emptyStringIsFalsy(item.gender),
        glasses_type: emptyStringIsFalsy(item.glasses_type),
        item_price: (item.frame && item.frame.price) || item.specialPrice || item.price || '',
        lens_type: emptyStringIsFalsy(item.lens_type),
        previous_category_id: emptyStringIsFalsy(item.previous_category_id),
        previous_category_name: emptyStringIsFalsy(item.previous_category_name),
        product_id: emptyStringIsFalsy(item.product_id),
        product_name: emptyStringIsFalsy(item.name),
        product_badge: getBadge(item.badges),
        quantity: Number(item.qty),
        size: item.frame ? emptyStringIsFalsy(item.frame.frameSize) : '',
        window_name: emptyStringIsFalsy(item.window_name),
        product_img: emptyStringIsFalsy(item.img),
    };
};

/**
 * Get fields for Global Data Layer for checkout page.
 * @param {Array<QuoteItemType>} products - customer data
 * @returns {CheckoutDataForGlobalDataLayerType} - returned checkout data prepared for Global Data Layer.
 */
export function getCheckoutDataGlobalDataLayer(
    products: Array<QuoteItemType>,
): CheckoutDataForGlobalDataLayerType {
    return {
        page_type_param1: 'OTHER',
        page_type_param2: 'CHECKOUT',
        products: products.map(prepareProductData),
    };
}
